"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var _ref$palette = _ref.palette,
    secondary = _ref$palette.secondary,
    primary = _ref$palette.primary;
  return {
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '58px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: secondary.main,
      color: '#efefef',
      padding: '0 0 0 24px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.26)',
      zIndex: 1400
    },
    wrapperLeft: {
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    wrapperRight: {
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      '& > div:first-child > button': {
        minWidth: '20px',
        paddingRight: '0px'
      }
    },
    menuButton: {
      width: '27px',
      height: '34px',
      textAlign: 'center',
      position: 'relative',
      transform: 'rotate(0deg)',
      transition: '.5s ease-in-out',
      cursor: 'pointer',
      '& > span': {
        display: 'block',
        position: 'absolute',
        height: '2px',
        width: '16px',
        background: '#fff',
        borderRadius: '9px',
        opacity: 1,
        left: '7px',
        transform: 'rotate(0deg)',
        transition: '.25s ease-in-out',
        '&:nth-child(1)': {
          top: '10px'
        },
        '&:nth-child(2)': {
          top: '15px'
        },
        '&:nth-child(3)': {
          top: '20px'
        }
      },
      '&.open > span': {
        '&:nth-child(1)': {
          top: '16px',
          transform: 'rotate(135deg)'
        },
        '&:nth-child(2)': {
          opacity: 0,
          left: '-10px'
        },
        '&:nth-child(3)': {
          top: '16px',
          transform: 'rotate(-135deg)'
        }
      }
    },
    menuButtonText: {
      fontSize: '10px',
      position: 'absolute',
      top: '25px',
      left: '4px'
    },
    logoParent: {
      backgroundColor: primary.main,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 24px',
      marginLeft: '26px',
      width: '150px'
    },
    logo: {
      display: 'block',
      maxHeight: '16px'
    },
    disabledButton: {
      fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      fontSize: '12px',
      letterSpacing: 1.5,
      backgroundColor: '#222222',
      maxHeight: '100%',
      color: '#ffffff',
      padding: '13px 20px',
      borderRadius: 0,
      fontWeight: 500,
      pointerEvents: 'none',
      '& > span': {
        color: '#d3d3d3'
      }
    },
    button: {
      fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      fontSize: '12px',
      letterSpacing: 1.5,
      backgroundColor: '#222222',
      maxHeight: '100%',
      color: '#ffffff',
      padding: '13px 20px',
      borderRadius: 0,
      fontWeight: 500,
      '&:hover': {
        '& > span': {
          color: '#d3d3d3'
        }
      }
    },
    badge: {
      '& .MuiBadge-badge': {
        color: '#fff',
        backgroundColor: '#FA6060',
        minWidth: '16px',
        height: '16px'
      }
    },
    bell: {
      height: '22px',
      width: '19px',
      cursor: 'pointer'
    }
  };
}, {
  name: 'PortalHeader'
});
exports.useStyles = useStyles;